module.exports = __webpack_public_path__ + "img/paragraphcentered.dca0fa1d.png";